<template>
	<div>
		<h1>Bye!</h1>
	</div>
</template>
<script>
export default {
  name: 'GoodbyePage',
  mounted(){
    this.$API.apiGET("/logout",true);
  	this.$API.loggedIn=false;
    this.$API.user={};
    this.$API.token="";
    this.$API.title="Logging out...";
  	setTimeout(()=>{
  		this.$router.push("/login");
  	},2000)
  }
}
</script>